import { render, staticRenderFns } from "./media-table.vue?vue&type=template&id=3968a15e&scoped=true&"
import script from "./media-table.ts?vue&type=script&lang=ts&"
export * from "./media-table.ts?vue&type=script&lang=ts&"
import style0 from "./media-table.scss?vue&type=style&index=0&id=3968a15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3968a15e",
  null
  
)

export default component.exports